<script setup lang="ts">
import { UseFetchReturn } from '@vueuse/core';
import { computed, watchEffect } from 'vue';

import ContentNotFound from './ContentNotFound.vue';
import SomethingWentWrong from './SomethingWentWrong.vue';

const props = withDefaults(
    defineProps<{
        request?: UseFetchReturn<any>;
        loading?: boolean;
        compact?: boolean;
        retry?: () => void | Promise<void>;
    }>(),
    { loading: undefined },
);

const statusCode = computed(() => props.request?.statusCode.value);
const ok = computed(() => props.request?.response.value?.ok);

function retryRequest() {
    return props.retry ? props.retry() : props.request?.execute();
}

watchEffect(() => {
    props.request?.onFetchError(() => {
        props.request?.error.value?.preventAlert?.();
    });
});
</script>

<template>
    <div v-if="loading ?? request?.isFetching.value" class="spinner spinner--block" />

    <template v-else-if="request?.isFinished.value">
        <ContentNotFound v-if="statusCode === 404" :class="{ 'placeholder--compact': compact }" />

        <SomethingWentWrong
            v-else-if="statusCode === 429"
            title="Woah, you're going a bit too fast!"
            detail="Try again in a minute."
            :retry="retryRequest"
            :class="{ 'placeholder--compact': compact }"
        />

        <SomethingWentWrong
            v-else-if="!ok"
            :retry="retryRequest"
            :class="{ 'placeholder--compact': compact }"
        />
    </template>

    <slot v-if="!request || ((request?.isFinished.value || loading === false) && ok)" />
</template>
